import { render, staticRenderFns } from "./ServiceTypes.vue?vue&type=template&id=d35356a8&scoped=true&"
import script from "./ServiceTypes.vue?vue&type=script&lang=js&"
export * from "./ServiceTypes.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTypes.vue?vue&type=style&index=0&id=d35356a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35356a8",
  null
  
)

export default component.exports